module.exports = __webpack_public_path__ + "assets/images/SecondaryShade.3261f177724e40c0c719b9b081a2fe9d.png";